export default __webpack_public_path__ + "static/media/mca.1502689c.jpg";